export default {
  methods: {
    async withApiErrorHandling(callback, errorProperty, loadingProperty = null) {
      this[errorProperty].errorMessage = null;
      this[errorProperty].errors = {};
      if (loadingProperty) {
        this[loadingProperty] = true;
      }
      try {
        return await callback.call(this);
      } catch (e) {
        if (e.name === 'ApiError') {
          this[errorProperty].errorMessage = e.message;
          this[errorProperty].errors = e.data;
        }
        throw e;
      } finally {
        if (loadingProperty) {
          this[loadingProperty] = false;
        }
      }
    },
    getInitialErrorData() {
      return {
        errorMessage: null,
        errors: {},
      };
    },
    resetError(errorProperty) {
      this[errorProperty] = this.getInitialErrorData();
    },
  },
};
